<template>
    <DsDropdown
        icons
        position="bottom-end"
        disable-scroll
    >
        <template #default>
            <DsIconButton name="more-vertical" />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li class="dropdown-menu-item" @click="$emit('export-html')">
                    <DsIcon name="download" />

                    {{ $t('unlayerBuilder.templateSelection.menu.exportHtml') }}
                </li>

                <li class="dropdown-menu-item" @click="() => {}">
                    <DsIcon name="message-square" />

                    {{ $t('unlayerBuilder.templateSelection.menu.shareFeedback') }}
                </li>

                <li class="dropdown-menu-item" @click="() => {}">
                    <DsIcon name="help-circle" />

                    {{ $t('global.learnMore.sentenceCase') }}
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
export default {};
</script>
